// src/hooks/useCategoryQuery.ts
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { CategoryService, Category } from '../Services/categoryService';

export const CATEGORY_QUERY_KEYS = {
  all: ['categories'] as const,
  allCategories: () => ['categories', 'all'] as const,
};

export const useAllCategoriesQuery = () => {
  return useQuery({
    queryKey: CATEGORY_QUERY_KEYS.allCategories(),
    queryFn: CategoryService.getAllCategories.bind(CategoryService),
    staleTime: 1000 * 60 * 10,
  });
};

export const useInvalidateCategories = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: CATEGORY_QUERY_KEYS.all });
};